import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '../../common/ui/save-filter-dialog-base/__generated__/saveFilterDialogBaseQuery.graphql';

type EntryPointParams = {
	filterAri?: string;
};

export const updateFilterDialogEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-issue-navigator-update-filter-dialog-content" */ './index'
			),
	),
	getPreloadProps: ({ filterAri }: EntryPointParams) => ({
		queries: {
			filterDataQuery: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					filterAri: filterAri ?? '',
					includeFilter: !!filterAri,
				},
			},
		},
	}),
});
